import React from 'react'

import { Icon } from '@acorns/icons'
import { ToastNotification, ToastPosition, handleUpdateToast } from '@acorns/web-components'
import styled from 'styled-components'

const Container = styled.div`
  .Toastify__toast {
    justify-content: center;
  }

  .Toastify__toast-body {
    background-color: ${props => props.theme.colors.purple};
  }

  .Toastify__toast-body {
    width: auto;
    min-width: auto;
  }

  svg {
    width: 40px;
    padding: 8px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    flex-shrink: 0;
  }

  path {
    &&& {
      fill: white;
    }
  }
`

export const showToast = ({ title = '', body = '' }) => {
  handleUpdateToast({
    title,
    body,
    customIcon: Icon.AlertGreyFv,
  })
}

export const Toast = () => (
  <Container>
    <ToastNotification
      position={ToastPosition.bottomCenter}
      shouldDismiss={true}
      hasCloseButton={true}
    />
  </Container>
)
